/* Laag1 Product Configurator â€” SFP transceivers + patchkabels */
(function() {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  var handle = window.location.pathname.split('/products/')[1].split('?')[0].split('/')[0];
  if (!handle) return;

  fetch('/products/' + handle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(product) {
      var tags = product.tags || [];
      var tagSet = {};
      tags.forEach(function(t) { tagSet[t.trim()] = true; tagSet[t.trim().toLowerCase()] = true; });

      var isCable = !!tagSet['patchkabel'];
      var isSFP = !!(tagSet['cwdm'] || tagSet['bidi'] || tagSet['dwdm']);

      if (isCable) return runCableConfigurator(product, tagSet);
      if (isSFP)   return runSFPConfigurator(product, tagSet);
    });

  /* ============================================================
     SFP CONFIGURATOR (CWDM / BiDi / DWDM) â€” cross-link speed/afstand/kleur
     ============================================================ */
  function runSFPConfigurator(product, tagSet) {
    var ptype = '', speed = '', kleur = '', afstand = '';
    (product.tags || []).forEach(function(t) {
      t = t.trim();
      var tl = t.toLowerCase();
      if (tl === 'cwdm' || tl === 'bidi' || tl === 'dwdm') ptype = tl;
      if (t === '1G' || t === '10G') speed = t;
      if (t.indexOf('kleur:') === 0) kleur = t.replace('kleur:', '');
      if (t.indexOf('afstand:') === 0) afstand = t.replace('afstand:', '');
    });
    if (!ptype) return;

    function fetchAllPagesSFP(pageNum, acc, cb) {
      fetch('/collections/' + ptype + '/products.json?limit=250&page=' + pageNum)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var items = data.products || [];
          acc = acc.concat(items);
          if (items.length === 250 && pageNum < 5) fetchAllPagesSFP(pageNum + 1, acc, cb);
          else cb(acc);
        })
        .catch(function() { cb(acc); });
    }
    fetchAllPagesSFP(1, [], function(allProducts) {
        var related = {};
        var allSpeeds = new Set(), allAfstanden = new Set(), allKleuren = new Set();
        (allProducts || []).forEach(function(p) {
          var ptags = p.tags || [];
          var ps = '', pa = '', pk = '', ok = false;
          ptags.forEach(function(t) {
            t = t.trim();
            if (t.toLowerCase() === ptype) ok = true;
            if (t === '1G' || t === '10G') ps = t;
            if (t.indexOf('kleur:') === 0) pk = t.replace('kleur:', '');
            if (t.indexOf('afstand:') === 0) pa = t.replace('afstand:', '');
          });
          if (ok && ps && pk) {
            related[p.handle] = { s: ps, a: pa, k: pk, u: '/products/' + p.handle };
            allSpeeds.add(ps);
            if (pa) allAfstanden.add(pa);
            allKleuren.add(pk);
          }
        });
        if (Object.keys(related).length < 2) return;

        var html = renderConfiguratorShell();
        if (allSpeeds.size > 1) {
          html += renderGroup('Snelheid', 'speed', Array.from(allSpeeds).sort(), speed);
        }
        if (allAfstanden.size > 0) {
          html += renderGroup('Zendafstand', 'afstand',
            Array.from(allAfstanden).sort(function(a, b) { return parseInt(a) - parseInt(b); }), afstand);
        }
        html += renderGroup('Kleur / Golflengte', 'kleur', Array.from(allKleuren).sort(), kleur);
        html += '</div>';
        injectConfigurator(html);

        var find = function(s, a, k) {
          for (var h in related) {
            var p = related[h];
            if ((!s || p.s === s) && (!a || p.a === a) && (!k || p.k === k)) return p;
          }
          return null;
        };
        bindSFP(related, find, speed, afstand, kleur);
      });
  }

  function bindSFP(related, find, speed, afstand, kleur) {
    var cfg = document.querySelector('.laag1-configurator');
    if (!cfg) return;
    cfg.addEventListener('click', function(e) {
      var opt = e.target.closest('.laag1-cfg-opt');
      if (!opt || opt.classList.contains('active')) return;
      e.preventDefault();
      var s = speed, a = afstand, k = kleur;
      var t = opt.dataset.t, v = opt.dataset.val;
      if (t === 'speed') s = v;
      if (t === 'afstand') a = v;
      if (t === 'kleur') k = v;

      /* Prioriteer de geklikte dimensie: behoud v waar mogelijk, varieer de rest */
      var b = null;
      if (t === 'afstand') {
        b = find(s, v, k) || find(s, v, null) || find(null, v, k) || find(null, v, null);
      } else if (t === 'kleur') {
        b = find(s, a, v) || find(s, null, v) || find(null, a, v) || find(null, null, v);
      } else if (t === 'speed') {
        b = find(v, a, k) || find(v, a, null) || find(v, null, k) || find(v, null, null);
      }
      /* Ultimate fallback (geklikte waarde bestaat niet in assortiment) */
      if (!b) {
        b = find(s, a, k) || find(s, a, null) || find(s, null, k) || find(null, a, k)
          || find(s, null, null) || find(null, a, null) || find(null, null, k);
      }
      if (b && b.u && b.u !== window.location.pathname) window.location.href = b.u;
    });
    cfg.querySelectorAll('[data-cfg=afstand] .laag1-cfg-opt').forEach(function(el) {
      el.classList.toggle('unavailable', !find(speed, el.dataset.val, kleur));
    });
    cfg.querySelectorAll('[data-cfg=kleur] .laag1-cfg-opt').forEach(function(el) {
      el.classList.toggle('unavailable', !find(speed, afstand, el.dataset.val));
    });
    cfg.querySelectorAll('[data-cfg=speed] .laag1-cfg-opt').forEach(function(el) {
      el.classList.toggle('unavailable', !find(el.dataset.val, null, kleur));
    });
  }

  /* ============================================================
     CABLE CONFIGURATOR â€” cross-link lengte binnen zelfde group tag.
     Groep = zelfde connector-combi + polish + fiber (bv
     'duplex-lc-apc-lc-apc-os2'). Variant = lengte.
     ============================================================ */
  function runCableConfigurator(product, tagSet) {
    var myGroup = '', myLength = '', myFiber = '', kabelType = '';
    (product.tags || []).forEach(function(t) {
      t = t.trim();
      if (t.indexOf('group:') === 0) myGroup = t.replace('group:', '');
      if (t.indexOf('lengte:') === 0) myLength = t.replace('lengte:', '');
      if (t.indexOf('fiber:') === 0) myFiber = t.replace('fiber:', '');
      if (t === 'duplex' || t === 'Duplex') kabelType = 'duplex';
      if (t === 'simplex' || t === 'Simplex') kabelType = 'simplex';
    });
    if (!myGroup || !kabelType) return;

    /* Haal alle producten op (multi-page want collections kunnen >250 items hebben) */
    function fetchAllPages(pageNum, accumulator, cb) {
      fetch('/collections/' + kabelType + '/products.json?limit=250&page=' + pageNum)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var items = data.products || [];
          accumulator = accumulator.concat(items);
          if (items.length === 250 && pageNum < 5) {
            fetchAllPages(pageNum + 1, accumulator, cb);
          } else {
            cb(accumulator);
          }
        })
        .catch(function() { cb(accumulator); });
    }

    fetchAllPages(1, [], function(allProducts) {
        var groupMembers = {};  /* group -> { length -> url } */
        var allGroups = new Set();
        var allLengths = new Set();

        (allProducts || []).forEach(function(p) {
          var ptags = p.tags || [];
          var pg = '', pl = '', pf = '';
          ptags.forEach(function(t) {
            t = t.trim();
            if (t.indexOf('group:') === 0) pg = t.replace('group:', '');
            if (t.indexOf('lengte:') === 0) pl = t.replace('lengte:', '');
            if (t.indexOf('fiber:') === 0) pf = t.replace('fiber:', '');
          });
          if (!pg || !pl) return;
          if (!groupMembers[pg]) groupMembers[pg] = {};
          groupMembers[pg][pl] = '/products/' + p.handle;
          allGroups.add(pg);
          if (pg === myGroup) allLengths.add(pl);
        });

        if (allLengths.size < 2) return;

        /* Sort lengths numerically: '0-25m', '0-5m', '1m', '1-5m', '2m', ..., '70m' */
        function lengthNum(l) {
          var n = l.replace('m', '').replace(/-/g, '.');
          return parseFloat(n);
        }
        var sortedLengths = Array.from(allLengths).sort(function(a, b) { return lengthNum(a) - lengthNum(b); });

        /* Check of er andere fibers zijn voor dezelfde connector-combi
           (bv duplex-lc-upc-lc-upc-os2 vs duplex-lc-upc-lc-upc-om3) */
        var mySuffix = myGroup.replace(/-o[ms]\d+$/, '');
        var alternateFibers = new Set();
        allGroups.forEach(function(g) {
          if (g.indexOf(mySuffix + '-') === 0 && g !== myGroup) {
            var fm = g.match(/-(o[ms]\d+)$/);
            if (fm) alternateFibers.add(fm[1].toUpperCase());
          }
        });
        if (alternateFibers.size > 0) alternateFibers.add(myFiber);

        var html = renderConfiguratorShell();

        /* Fiber-selector (alleen als er meerdere fiber-grades zijn voor deze connector-combi) */
        if (alternateFibers.size > 1) {
          html += renderGroup('Fiber grade', 'fiber',
            Array.from(alternateFibers).sort(), myFiber);
        }

        /* Lengte-selector */
        html += renderGroup('Lengte', 'lengte', sortedLengths.map(function(l) {
          return l.replace(/-/g, '.').replace('m', ' m');
        }), myLength.replace(/-/g, '.').replace('m', ' m'));

        html += '</div>';
        injectConfigurator(html);

        var cfg = document.querySelector('.laag1-configurator');
        if (!cfg) return;
        cfg.addEventListener('click', function(e) {
          var opt = e.target.closest('.laag1-cfg-opt');
          if (!opt || opt.classList.contains('active')) return;
          e.preventDefault();
          var t = opt.dataset.t, v = opt.dataset.val;

          if (t === 'lengte') {
            var lengteSlug = v.replace(' m', 'm').replace(/\./g, '-');
            var target = groupMembers[myGroup] && groupMembers[myGroup][lengteSlug];
            if (target && target !== window.location.pathname) window.location.href = target;
          }

          if (t === 'fiber') {
            var newGroup = mySuffix + '-' + v.toLowerCase();
            var mg = groupMembers[newGroup];
            if (mg) {
              var targetLength = mg[myLength] || Object.values(mg)[0];
              if (targetLength && targetLength !== window.location.pathname) window.location.href = targetLength;
            }
          }
        });
      });
  }

  /* sluit fetchAllPages callback */

  /* ============================================================
     Shared rendering + DOM insertion
     ============================================================ */
  function renderConfiguratorShell() {
    return '<div class="laag1-configurator">';
  }

  function renderGroup(label, key, values, selected) {
    var h = '<div class="laag1-cfg-group"><div class="laag1-cfg-label">' + label + '</div>';
    h += '<div class="laag1-cfg-opts" data-cfg="' + key + '">';
    values.forEach(function(v) {
      h += '<a href="#" class="laag1-cfg-opt' + (v === selected ? ' active' : '') + '" data-val="' + v + '" data-t="' + key + '">' + v + '</a>';
    });
    return h + '</div></div>';
  }

  function injectConfigurator(html) {
    var buyBlock = document.querySelector('.buy-buttons-block');
    if (buyBlock) { buyBlock.insertAdjacentHTML('beforebegin', html); return; }
    var buyForm = document.querySelector('product-form-component');
    if (buyForm) { buyForm.insertAdjacentHTML('beforebegin', html); return; }
    var desc = document.querySelector('rte-formatter.rte');
    if (desc) desc.insertAdjacentHTML('beforebegin', html);
  }
})();
